<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="flex-no-shrink w-12 h-12 rounded-lg text-white p-1"
        :class="this.module.settings.icon_color ? this.module.settings.icon_color : 'bg-tertiary'"
      >
        <icon :name="this.module.settings.icon" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        {{ module.title }}
      </h3>
    </div>
    <p class="text-base leading-tight mb-6" v-html="nl2br(module.settings.description)"></p>
    <button
      @click="login"
      target="_blank"
      class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
    >
      {{ module.settings.cta }}
    </button>
  </div>
</template>

<script>
import { nl2br } from '@/helpers'
import api from '@/http'
import { mapState } from 'vuex'

export default {
  props: ['module'],

  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
    nl2br,
    login () {
      api.get(`/feestreet/sso`, {
        params: {
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        window.open(response.data.url, '_blank')
      })
    }
  }
}
</script>
